import React from "react";
import { ButtonGroup, Col, Row, Button } from "react-bootstrap";

const SizeButtons = ({ product, buttonClick, selectedSize }) => {
  const onTrigger = (size, index) => {
    buttonClick({ size, index });
  };

  return (
    <ButtonGroup>
      <Row className="d-flex flex-wrap justify-content-start">
        {product.size.map((s, i) => (
          <Col key={i} xs="auto">
            <Button
              variant="light"
              style={{
                border:
                  s.sizeType === selectedSize
                    ? "2px solid blue"
                    : "1px solid #ccc",
                backgroundColor: "white",
                padding: "10px 20px",
                fontSize: "16px",
                color: "black",
                borderRadius: "5px",
                boxShadow: "none",
              }}
              onClick={() => onTrigger(s.sizeType, i)}
            >
              {s.sizeType} GB
            </Button>
          </Col>
        ))}
      </Row>
    </ButtonGroup>
  );
};

export default SizeButtons;

// import React from "react";
// import {
//     ButtonGroup,
//     Col,
//     Row,
//     Button,
//     OverlayTrigger,
//     Tooltip,
// } from "react-bootstrap";
// import { sizeTypeToInfo } from "../../Utils/size";

// const SizeButtons = ({ product, styles, buttonClick, selectedSize }) => {
//     const onTrigger = (s, i) => {
//         buttonClick({ size: s, index: i });
//     };

//     return (
//         <div>
//             <ButtonGroup>
//                 <Row>
//                     {product.size.map((s, i) => {
//                         return (
//                             <Col
//                                 key={i}
//                                 xs={1}
//                                 md={1}
//                                 lg={1}
//                                 className="mx-2 my-1"
//                             >
//                                 <OverlayTrigger
//                                     placement="top"
//                                     overlay={
//                                         <Tooltip id="button-tooltip">
//                                             {sizeTypeToInfo(s.sizeType)}
//                                         </Tooltip>
//                                     }
//                                 >
//                                     <Button
//                                         variant={
//                                             s.sizeType === selectedSize
//                                                 ? "primary"
//                                                 : "light"
//                                         }
//                                         style={styles.btn_circle}
//                                         onClick={() => onTrigger(s.sizeType, i)}
//                                     >
//                                         {s.sizeType}
//                                     </Button>
//                                 </OverlayTrigger>
//                             </Col>
//                         );
//                     })}
//                 </Row>
//             </ButtonGroup>
//         </div>
//     );
// };

// export default SizeButtons;
